import { createSlice } from '@reduxjs/toolkit'

import { MOBILE_REGEX } from '@Root/contants'

export interface BrowserState {
  isMobile: boolean
  isIphone: boolean
  isAndroidApp: boolean
  isIosApp: boolean
  isLandApp: boolean
  isIpad: boolean
  isAndroid: boolean
  isChrome: boolean
  isSafari: boolean
  isPayApp: boolean
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const initialState: BrowserState = {
  isMobile: MOBILE_REGEX.IS_MOBILE.test(navigator.userAgent),
  isIphone: MOBILE_REGEX.IS_IPHONE.test(navigator.userAgent),
  isAndroidApp: MOBILE_REGEX.IS_ANDROID_APP.test(navigator.userAgent),
  isIosApp: MOBILE_REGEX.IS_IOS_APP.test(navigator.userAgent),
  isLandApp: MOBILE_REGEX.IS_LAND_APP.test(navigator.userAgent),
  isNaverApp: MOBILE_REGEX.IS_NAVER_APP.test(navigator.userAgent),
  isIpad:
    MOBILE_REGEX.IS_IPAD.test(navigator.userAgent) ||
    (MOBILE_REGEX.IS_IPAD.test(navigator.platform) && !window?.['MSStream']) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window?.['MSStream']),
  isAndroid: MOBILE_REGEX.IS_ANDROID.test(navigator.userAgent),
  isChrome: MOBILE_REGEX.IS_CHROME.test(navigator.userAgent),
  isSafari: MOBILE_REGEX.IS_SAFARI.test(navigator.userAgent),
  isPayApp: MOBILE_REGEX.IS_PAY_APP.test(navigator.userAgent),
} as BrowserState

export const myhouseBrowserSlice = createSlice({
  name: 'myhouseBrowser',
  initialState,
  reducers: {
    initializeState: (state: BrowserState) => {
      Object.assign(state, initialState)
    },
  },

  extraReducers: {},
})

export const { initializeState } = myhouseBrowserSlice.actions

export default myhouseBrowserSlice.reducer
